module.exports = __webpack_public_path__ + "static/assets/510201fee0eb0012cff8c51de7573726.png";